var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:_vm.bookingStatusClass,attrs:{"size":"sm"}},[_c('i',{staticClass:"ncc-icon mr-1",class:_vm.bookingTypeClass,attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("booking.bookingStates." + _vm.booking.bookingStatus))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }